<template>
  <main class="main-container">
    <section class="double-top-pad" aria-labelledby="contact-title">
      <div class="top-block"></div>

      <div class="container">
        <div class="row contact-page">
          <div class="col-md-6 col-md-offset-3">
            <!-- Use H1 as page title -->
            <h1 id="contact-title">{{ contact.title }}</h1>

            <!-- Body text with semantic paragraphs -->
            <div class="page-paragraphs">
              <p v-for="(p, index) in contact.body" :key="index" v-html="p"></p>
            </div>

            <!-- Accessible contact list -->
            <ul class="contact-list">
              <li v-for="(item, index) in contact.array" :key="index">
                <a
                  :href="item.link"
                  target="_blank"
                  rel="noopener noreferrer"
                  :aria-label="`Contact via ${item.label}`"
                >
                  <i :class="item.class" aria-hidden="true"></i>
                  <span>{{ item.label }}</span>
                </a>
              </li>
            </ul>

            <!-- Back button as a link (semantic) -->
            <router-link
              to="/"
              class="block-button back-button"
              aria-label="Go back to homepage"
            >
              <div class="block-button back-button">
                <div class="mybutton-up">BACK</div>
                <div class="mybutton-down">BACK</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="name-section name-section-small" aria-hidden="true">
      <div class="name-section-inner name-section-inner-black"></div>
    </section>
  </main>
</template>

<style type="text/css"></style>

<script>
import { contact } from "../../content.json";
import { commontools } from "../mixins/Styling";

export default {
  mixins: [commontools],
  name: "contact",
  watch: {
    "$route.name": function (id) {
      window.scrollTo(0, 0);
    },
  },
  data() {
    return {
      contact,
    };
  },
  methods: {},
  created: function () {},
  mounted: function () {
    window.scrollTo(0, 0);
    // setTimeout(() => {
    //   this.manageWidows()
    // }, 100)
  },
  components: {},
};
</script>
